import { FC, ReactNode } from "react";
import { CXWorkspaceSettingsTopbar } from "./components/CXWorkspaceSettingsTopbar/CXWorkspaceSettingsTopbar";
import { CXWorkspaceSettingsSidebar } from "./components/CXWorkspaceSettingsSidebar";

interface CXWorkspaceSettingsLayoutProps {
  children: ReactNode;
}

export const CXWorkspaceSettingsLayout: FC<CXWorkspaceSettingsLayoutProps> = ({
  children,
}) => (
  <div className="flex h-full flex-col">
    <CXWorkspaceSettingsTopbar />
    <CXWorkspaceSettingsSidebar>{children}</CXWorkspaceSettingsSidebar>
  </div>
);
